import React from "react";
import {
  Navbar,
  Nav,
  Container,
  Form,
  FormControl,
  Button,
  Dropdown,
} from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./AdminHeader.css";

const AdminHeader = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirm = window.confirm("Are you sure you want to logout?");
    if (confirm) {
      localStorage.removeItem("token");
      navigate("/admin-login");
    }
  };

  return (
    <>
      <Navbar bg="" variant="dark" expand="lg" sticky="top" className="navbar">
        <Container fluid>
          <Navbar.Brand href="/dashboard" className="logo">
            Cars24 Admin
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="admin-navbar" />
          <Navbar.Collapse id="admin-navbar">
            <Nav className="me-auto">
              {/* <Nav.Link href="/dashboard">Dashboard</Nav.Link>
              <Nav.Link href="/users">Users</Nav.Link> */}
            </Nav>

            {/* Search */}

            {/* Profile Dropdown */}
            <Navbar.Brand href="/dashboard" className="logo">
              Welcome Admin
            </Navbar.Brand>
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="outline-light"
                id="dropdown-basic"
                className="d-flex align-items-center"
              >
                <FaUserCircle size={20} className="me-2" />
                Admin
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminHeader;
